module.exports = __webpack_public_path__ + "img/impact.33dd4946.jpg";